import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.ADITAMENTO.HISTORICO.BUSCAR_HISTORICOS]({ state }, idItemAta) {
		const { paginacao } = state
		const { data } = await api.aditamento.buscarHistoricoAditamento(idItemAta, paginacao)
		return data
	},
}
